import { Component, Inject, Input, OnDestroy, OnInit, } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AgreementsService, DepotService, ReportsService, IntegrationReportDataDto, IntegrationReportContainerDto, IntegrationReportShowFilter, IntegrationReportOrderStatus, IntegrationReportContainerStatus, IntegrationReportSortColumn, IntegrationReportSortType, AssetTypeClassification, CustomerLocationDto, AddAgreementRentalAmountsRequest, AgreementRentalAmountDto, AddAgreementActionsRequest, AgreementActionDto, IntegrationReportAgreementDto, AgreementActionContainerDto, ManualResetContainerDto, ManualResetDto } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import moment from 'moment';
import { SessionStorageService } from '../services/session-storage.service';
import { Router } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { VehicleTypeHelper } from '../helpers/VehicleTypeHelper';
import { LocalStorageService } from '../services/local-storage.service';
import { CustomerSettings } from '../services/customer-settings-service';
import { Observable } from 'rxjs';
import { forEach } from '@angular-devkit/schematics';
import { AuthService } from '../security/auth.service';

export class ContactDetailsDialogData {
  title: string;
  text: string;
  info: string;
  contactEmail: string;
  contactName: string;
  contactNumber: string;
  showCancel: boolean = true;
}

export class NotesDialogData {
  title: string;
  text: string;
  info: string;
  notes: string;
  showCancel: boolean = true;
}

export class RentalDialogData {
  title: string;
  text: string;
  isCustomRental: boolean = false;
  rentalAmount: number;
  showPrompt: boolean = true;
  showCancel: boolean = true;
}

export class ActionsDialogData {
  title: string;
  text: string;
  containers: ActionsDialogContainer[];
  isScheduled: boolean = false;
  showCancel: boolean = true;
}

export class ActionsDialogContainer {
  id: string;
  daysOnSite: number = 0;
  isChecked: boolean = false;
}

export class ResetDialogData {
  title: string;
  text: string;
  containers: ResetDialogContainer[];
  showCancel: boolean = true;
}

export class ResetDialogContainer {
  id: string;
  startDate: moment.Moment;
  resetDate: moment.Moment;
  daysOnSite: number = 0;
  isChecked: boolean = false;
}

export enum ShowMode {
  All = 1,
  NewOrders = 2,  
  ContainerOnSite = 3,
  NoContainerOnSite = 4,
  OnlyDiscrepancies = 5,
  SlowMovers = 6,
  RecentlyUpdated = 7,
  MissingCollection = 8,
  MovedContract = 9
}

export enum ContainerStatus {
  DifferentContainerSize = 1,
  DifferentContainerType = 2,  
  DifferentWaste = 3,
  Matched = 4,
  NotMatched = 5
}

export class DropDownListItem {
  constructor(id?: string, name?: string) {
    this.id = id,
    this.name = name;
  }

  id: string;
  name: string;
}

@Component({
    selector: 'app-integration-report-component',
    templateUrl: './integration-report.component.html',
    styleUrls: ['./integration-report.component.scss'],
    standalone: false
})
export class IntegrationReportComponent extends PagebaseComponent implements OnDestroy, OnInit {
  private readonly getDataDebounceMs = 300;
  @Input() showAdminOptions!: boolean;
    
  // Private variables
  customerId: string;
  data: IntegrationReportDataDto;
  locations: CustomerLocationDto[];
  locationsList: DropDownListItem[];
  filteredLocationsList: DropDownListItem[];
  depotList: DropDownListItem[];
  assetTypeList: DropDownListItem[];
  agreementList: DropDownListItem[] = [];
  filteredAgreementList: DropDownListItem[] = [];
  accountManagerList: DropDownListItem[] = [];
  accountCategoryList: DropDownListItem[] = [];
  accountCodeList: DropDownListItem[] = [];
  accountTypeList: DropDownListItem[] = [];
  customerList: DropDownListItem[] = [];
  wasteTypeList: DropDownListItem[] = [];
  selectedShowMode: string = ShowMode[ShowMode.ContainerOnSite];
  selectedAssetTypeId: string;
  selectedExternalReference: string;
  selectedAssetLocationId: string;
  selectedContainerStatus: string;
  selectedDepotId: string;
  selectedVehicleType: string;
  selectedAccountManager: string;
  selectedAccountCategory: string;
  selectedAccountCode: string;
  selectedAccountType: string;
  selectedCustomer: string;
  selectedWasteTypeNames: string[] = [];
  hasMultipleDepots: boolean = false;
  expandedAgreements: string[] = [];
  showOnlyDiscrepancies: boolean = false;
  showSlowMovers: boolean = false;
  showContainerOnSite: boolean = false;
  sortColumn: string = IntegrationReportSortColumn[IntegrationReportSortColumn.AgreementReference];
  sortDirection: string = IntegrationReportSortType[IntegrationReportSortType.Descending];
  locationSearchControl: UntypedFormControl = new UntypedFormControl();
  assetTypeSearchControl: UntypedFormControl = new UntypedFormControl();
  agreementSearchControl: UntypedFormControl = new UntypedFormControl();
  defaultRentalDays: number;
  defaultRentalAmountRoros: number;
  defaultRentalAmountSkips: number;
  showAccountCategory: boolean;
  showWasteStream: boolean;
  showLatestActionDate: boolean;
  showLatestActionDescription: boolean;
  showAccountType: boolean;
  disableSlowMovers: boolean = false;
  showSubFilter: boolean = false;
  showNewOrderDate: boolean = false;
  selectedSubFilterId: string = "";
  subFilterList: DropDownListItem[] = [];
  orderFromDate = new UntypedFormControl(new Date('2023-05-01'));
  NoContainerOnSiteFilterList: DropDownListItem[] = [
    new DropDownListItem(IntegrationReportOrderStatus[IntegrationReportOrderStatus.ExpectedContainerNotFound], "Expected container not found"),
    new DropDownListItem(IntegrationReportOrderStatus[IntegrationReportOrderStatus.ServiceCompleted], "Service Completed")
  ];
  NewOrdersFilterList: DropDownListItem[] = [
    new DropDownListItem(IntegrationReportOrderStatus[IntegrationReportOrderStatus.ContainerNotYetDelivered], "Container Not Yet Delivered"),
    new DropDownListItem(IntegrationReportOrderStatus[IntegrationReportOrderStatus.ServiceCompleted], "Service Completed"),
    new DropDownListItem(IntegrationReportOrderStatus[IntegrationReportOrderStatus.ContainerOnSite], "Container On Site")
  ];
 
  private apiCall;
  private getDataDebounceTimer: ReturnType<typeof setTimeout> | null = null;

  // Public variables
  ShowMode = ShowMode;
  ContainerStatus = ContainerStatus;
  loading: boolean = true;
  isAdmin: boolean = false;

  // Constuctor
  constructor(
    public dialog: MatDialog,
    private _agreementsService: AgreementsService,
    private _depotService: DepotService,
    private _reportsService: ReportsService,
    private sessionStorageService: SessionStorageService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private customerSettings: CustomerSettings,
    private authService: AuthService,
    pageHelperService: PageHelperService,
    applicationStatusService: ApplicationStatusService
    ) {
    super(pageHelperService, applicationStatusService, customerSettings, "Integration Report");
  }

  ngOnInit() {
    this.authService.isAdmin().then(result => {
      this.isAdmin = result;

      if (!this.isAdmin && this.showAdminOptions) {
        this.showAdminOptions = false;
        this.apiCall = null;
        this.unsubscribe();
      }
      if (this.isAdmin && this.showAdminOptions) {
        this.sessionStorageService.setItem("integration-report-selectedShowMode", ShowMode[ShowMode.RecentlyUpdated]);
        this.sessionStorageService.setItem("integration-report-selectedDepotId", "00000000-0000-0000-0000-000000000000");
      }
      if (!this.showAdminOptions) {
        this.sessionStorageService.setItem("integration-report-selectedShowMode", ShowMode[ShowMode.ContainerOnSite]);
        this.sessionStorageService.removeItem("integration-report-selectedDepotId");
      }
    })
  }

  ngOnDestroy() {
    this.unsubscribe()
  }

  unsubscribe() { 
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }

    if (this.getDataDebounceTimer) {
      clearTimeout(this.getDataDebounceTimer);
      this.getDataDebounceTimer = null;
    }
  }

  reset() {
    this.data = null;
    this.locations = [];
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }  
  }

  // Get the view data
  getData() {
    this.expandedAgreements = [];
    this.showAccountCategory = this.customerSettings.getUISetting("UI-ShowAccountCategory", "false") == "true";
    this.showWasteStream = this.customerSettings.getUISetting("UI-ShowWasteStream", "false") == "true";
    this.showLatestActionDate = this.customerSettings.getUISetting("UI-ShowLatestActionDate", "false") == "true";
    this.showLatestActionDescription = this.customerSettings.getUISetting("UI-ShowLatestActionDescription", "false") == "true";
    this.showAccountType = this.customerSettings.getUISetting("UI-ShowAccountType", "false") == "true";
    this.showLatestActionDate = this.showLatestActionDate;
    this.showLatestActionDescription = this.showLatestActionDescription;
    this.showAccountType = this.showAccountType;

    let selectedDepotId = this.sessionStorageService.getItem("integration-report-selectedDepotId");

    if(selectedDepotId) {
      this.selectedDepotId = selectedDepotId;
    }
    else {
      this.selectedDepotId = null;
    }
    let selectedAssetTypeId = this.sessionStorageService.getItem("integration-report-selectedAssetTypeId");
    if(selectedAssetTypeId) {
      this.selectedAssetTypeId = selectedAssetTypeId;
    }
    let selectedExternalReference = this.sessionStorageService.getItem("integration-report-selectedExternalReference");
    if(selectedExternalReference) {
      this.selectedExternalReference = selectedExternalReference;
    }    
    let selectedAssetLocationId = this.sessionStorageService.getItem("integration-report-selectedAssetLocationId");
    if(selectedAssetLocationId) {
      this.selectedAssetLocationId = selectedAssetLocationId;
    }
    let selectedContainerStatus = this.sessionStorageService.getItem("integration-report-selectedContainerStatus");
    if(selectedContainerStatus) {
      this.selectedContainerStatus = selectedContainerStatus;
    }
    let selectedVehicleType = this.sessionStorageService.getItem("dashboard-active-selectedVehicleType");
    if(selectedVehicleType) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }
    let selectedSubFilterId = this.sessionStorageService.getItem("dashboard-active-selectedSubFilterId");
    if(selectedSubFilterId) {
      selectedSubFilterId = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedSubFilterId"));
      this.selectedSubFilterId = selectedSubFilterId;
    }
    if(this.selectedSubFilterId) {
      selectedSubFilterId = this.selectedSubFilterId;
    }
    let selectedOrderDate = this.localStorageService.getItem("integration-report-selectedOrderDate");
    if(selectedOrderDate) {
      selectedOrderDate = JSON.parse(selectedOrderDate);
      this.orderFromDate = new UntypedFormControl(selectedOrderDate);
    }
    else {
      if (this.data?.defaultAgreementsFromDateString) {
        selectedOrderDate = this.data.defaultAgreementsFromDateString;
        this.orderFromDate = new UntypedFormControl(selectedOrderDate);
      }
    }
    let selectedShowMode = this.sessionStorageService.getItem("integration-report-selectedShowMode");
    if(selectedShowMode) {
      this.selectedShowMode = selectedShowMode;
    }
    if(this.selectedShowMode) {
      selectedShowMode = this.selectedShowMode;
    }
    if (selectedShowMode == ShowMode[ShowMode.SlowMovers]) {
      this.showSlowMovers = true;
    }
    else {
      this.showSlowMovers = false;
    }
    if (selectedShowMode == ShowMode[ShowMode.ContainerOnSite]) {
      this.showContainerOnSite = true;
    }
    else {
      this.showContainerOnSite = false;
    }    
    let selectedAccountManager = this.sessionStorageService.getItem("integration-report-selectedAccountManager");
    if(selectedAccountManager) {
      this.selectedAccountManager = selectedAccountManager;
    }
    let selectedAccountCode = this.sessionStorageService.getItem("integration-report-selectedAccountCode");
    if(selectedAccountCode) {
      this.selectedAccountCode = selectedAccountCode;
    }
    let selectedAccountType = this.sessionStorageService.getItem("integration-report-selectedAccountType");
    if(selectedAccountType) {
      this.selectedAccountType = selectedAccountType;
    }
    let selectedAccountCategory = this.sessionStorageService.getItem("integration-report-selectedAccountCategory");
    if(selectedAccountCategory) {
      this.selectedAccountCategory = selectedAccountCategory;
    }
    let selectedCustomer = this.sessionStorageService.getItem("integration-report-selectedCustomer");
    if(selectedCustomer) {
      this.selectedCustomer = selectedCustomer;
    }
    const activeCustomerId = this.pageHelperService.selectedCompanyId;
    let selectedWasteTypeNames = this.getStoredWasteTypeNames(activeCustomerId);
    if (selectedWasteTypeNames?.length) {
      this.selectedWasteTypeNames = selectedWasteTypeNames;
    }
    else {
      this.selectedWasteTypeNames = [];
    }
    if (!this.showSlowMovers) {
      this.selectedWasteTypeNames = [];
      selectedWasteTypeNames = [];
    }
    if (this.showAdminOptions &&
      (((!selectedShowMode || selectedShowMode == ShowMode[ShowMode.RecentlyUpdated]) && (!selectedDepotId || selectedDepotId == "00000000-0000-0000-0000-000000000000"))
      || (selectedShowMode == ShowMode[ShowMode.ContainerOnSite] && selectedDepotId == null))) {
      selectedShowMode = ShowMode[ShowMode.RecentlyUpdated];
      selectedDepotId = "00000000-0000-0000-0000-000000000000";
      this.selectedShowMode = ShowMode[ShowMode.RecentlyUpdated];
      this.selectedDepotId = "00000000-0000-0000-0000-000000000000";
      this.sessionStorageService.setItem("integration-report-selectedShowMode", ShowMode[ShowMode.RecentlyUpdated]);
      this.sessionStorageService.setItem("integration-report-selectedDepotId", "00000000-0000-0000-0000-000000000000");
    }
    else if (!this.showAdminOptions && (selectedShowMode == ShowMode[ShowMode.RecentlyUpdated] || selectedShowMode == ShowMode[ShowMode.MissingCollection] || selectedShowMode == ShowMode[ShowMode.MovedContract])) {
      selectedShowMode = ShowMode[ShowMode.ContainerOnSite];
      selectedDepotId = null;
      this.selectedShowMode = ShowMode[ShowMode.ContainerOnSite];
      this.selectedDepotId = null;
      this.sessionStorageService.setItem("integration-report-selectedShowMode", ShowMode[ShowMode.ContainerOnSite]);
      this.sessionStorageService.removeItem("integration-report-selectedDepotId");
    }

    if(this.customerId != this.pageHelperService.selectedCompanyId) {
      console.log("loading depots");
      this.loading = true;
      this.setIsLoading(this.loading);

      this.customerId = this.pageHelperService.selectedCompanyId
      this.wasteTypeList = this.getStoredWasteTypeList(this.customerId);
      this._depotService.getUserDepots(this.pageHelperService.selectedCompanyId).subscribe(data => {
        const depotList: DropDownListItem[] = [];
        data.forEach(depot => {
          let depotItem = new DropDownListItem()
          depotItem.id = depot.id;
          depotItem.name = depot.name;
          depotList.push(depotItem)
        });
        
        this.hasMultipleDepots = depotList.length > 1;
        this.depotList = depotList;
        this.loading = false;
        this.setIsLoading(this.loading);
      });
    }

    if (!selectedWasteTypeNames?.length) {
      this.clearStoredWasteTypeList(activeCustomerId);
      this.wasteTypeList = [];
    }

    console.log("loading data");
    this.loading = true;
    this.setIsLoading(this.loading);
    
    this.apiCall = this._reportsService
      .getIntegrationReport(
        this.customerId,
        this.getDepotId(selectedDepotId),
        [],
        this.getAssetTypeClassification(selectedVehicleType),
        this.getShowMode(selectedShowMode),
        this.getOrderStatus(selectedShowMode, selectedSubFilterId),
        this.getContainerStatus(selectedContainerStatus),
        this.getAgreementsFromDate(selectedOrderDate),
        this.getAssetTypeId(selectedAssetTypeId),
        selectedExternalReference,
        this.getWasteTypeNames(selectedWasteTypeNames),
        selectedAssetLocationId,
        selectedAccountCode,
        selectedAccountManager,
        selectedAccountCategory,
        selectedAccountType,
        selectedCustomer,
        this.getSortColumn(this.sortColumn),
        this.getSortType(this.sortDirection),
        1,
        9999)
      .subscribe(data => {
        this.data = data;
        this.locations = data.customerLocations;
        this.defaultRentalDays = data.defaultRentalDays;
        this.defaultRentalAmountRoros = data.defaultRentalAmountRoros;
        this.defaultRentalAmountSkips = data.defaultRentalAmountSkips;
        this.loading = false;
        this.checkForSubFilter();        
        this.loadListData(data);
        this.setIsLoading(this.loading);
      }, error => {
        debugger;
      });
  }

  getDepotId(selectedDepotId) {
    if (!selectedDepotId) {
      return null;
    }

    return selectedDepotId;
  }

  getAssetTypeId(selectedAssetTypeId) {
    if (!selectedAssetTypeId) {
      return null;
    }

    return selectedAssetTypeId;
  }

  getWasteTypeNames(selectedWasteTypeNames: string[]): string[] | null {
    if (!selectedWasteTypeNames || !selectedWasteTypeNames.length) {
      return null;
    }

    return selectedWasteTypeNames;
  }

  getStoredWasteTypeNames(customerId: string): string[] {
    if (!customerId) {
      return [];
    }

    const storageKey = this.getSelectedWasteTypeNamesStorageKey(customerId);
    const selectedWasteTypeNames = this.sessionStorageService.getItem(storageKey);
    if (!selectedWasteTypeNames) {
      return [];
    }

    try {
      const parsed = JSON.parse(selectedWasteTypeNames);
      if (Array.isArray(parsed)) {
        return parsed.filter((name: string) => !!name);
      }
    } catch {
      return [];
    }

    return [];
  }

  saveStoredWasteTypeNames(customerId: string, selectedWasteTypeNames: string[]) {
    if (!customerId) {
      return;
    }

    const storageKey = this.getSelectedWasteTypeNamesStorageKey(customerId);
    if (!selectedWasteTypeNames || !selectedWasteTypeNames.length) {
      this.sessionStorageService.removeItem(storageKey);
      return;
    }

    this.sessionStorageService.setItem(storageKey, JSON.stringify(selectedWasteTypeNames));
  }

  clearStoredWasteTypeNames(customerId: string) {
    if (!customerId) {
      return;
    }

    const storageKey = this.getSelectedWasteTypeNamesStorageKey(customerId);
    this.sessionStorageService.removeItem(storageKey);
  }

  getStoredWasteTypeList(customerId: string): DropDownListItem[] {
    if (!customerId) {
      return [];
    }

    const storageKey = this.getWasteTypeListStorageKey(customerId);
    const storedWasteTypeList = this.sessionStorageService.getItem(storageKey);
    if (!storedWasteTypeList) {
      return [];
    }

    try {
      const parsed = JSON.parse(storedWasteTypeList);
      if (!Array.isArray(parsed)) {
        return [];
      }

      return parsed
        .filter((item: any) => !!item?.id && !!item?.name)
        .map((item: any) => new DropDownListItem(item.id, item.name));
    } catch {
      return [];
    }
  }

  saveStoredWasteTypeList(customerId: string, wasteTypeList: DropDownListItem[]) {
    if (!customerId) {
      return;
    }

    const storageKey = this.getWasteTypeListStorageKey(customerId);
    this.sessionStorageService.setItem(storageKey, JSON.stringify(wasteTypeList || []));
  }

  clearStoredWasteTypeList(customerId: string) {
    if (!customerId) {
      return;
    }

    const storageKey = this.getWasteTypeListStorageKey(customerId);
    this.sessionStorageService.removeItem(storageKey);
  }

  getSelectedWasteTypeNamesStorageKey(customerId: string) {
    return `integration-report-selectedWasteTypeName-${customerId}`;
  }

  getWasteTypeListStorageKey(customerId: string) {
    return `integration-report-wasteTypeList-${customerId}`;
  }

  getAssetTypeClassification(selectedVehicleType: string) {
    return !selectedVehicleType ? AssetTypeClassification.All : VehicleTypeHelper.ConvertVehicleTypeNameToAssetTypeClassification(selectedVehicleType)
  }

  getShowMode(selectedShowMode: string) {
    if (!selectedShowMode) {
      return IntegrationReportShowFilter.None;
    }

    if (selectedShowMode == ShowMode[ShowMode.NewOrders]) {
      return IntegrationReportShowFilter.NewAgreements;
    }

    if (selectedShowMode == ShowMode[ShowMode.ContainerOnSite]) {
      return IntegrationReportShowFilter.ContainerOnSite;
    }

    if (selectedShowMode == ShowMode[ShowMode.NoContainerOnSite]) {
      return IntegrationReportShowFilter.NoContainerOnSite;
    }

    if (selectedShowMode == ShowMode[ShowMode.OnlyDiscrepancies]) {
      return IntegrationReportShowFilter.Discrepancies;
    }

    if (selectedShowMode == ShowMode[ShowMode.SlowMovers]) {
      return IntegrationReportShowFilter.SlowMovers;
    }

    if (selectedShowMode == ShowMode[ShowMode.RecentlyUpdated]) {
      return IntegrationReportShowFilter.RecentlyUpdated;
    }

    if (selectedShowMode == ShowMode[ShowMode.MissingCollection]) {
      return IntegrationReportShowFilter.MissingCollection;
    }

    if (selectedShowMode == ShowMode[ShowMode.MovedContract]) {
      return IntegrationReportShowFilter.MovedContract;
    }

    return IntegrationReportShowFilter.All;
  }

  getOrderStatus(selectedShowMode: string, selectedSubFilterId: string) {
    if (selectedShowMode == ShowMode[ShowMode.NoContainerOnSite]) {
      if (selectedSubFilterId == IntegrationReportOrderStatus[IntegrationReportOrderStatus.ExpectedContainerNotFound]) {
        return IntegrationReportOrderStatus.ExpectedContainerNotFound;
      }

      if (selectedSubFilterId == IntegrationReportOrderStatus[IntegrationReportOrderStatus.ServiceCompleted]) {
        return IntegrationReportOrderStatus.ServiceCompleted;
      }
    }

    if (selectedShowMode == ShowMode[ShowMode.NewOrders]) {
      if (selectedSubFilterId == IntegrationReportOrderStatus[IntegrationReportOrderStatus.ContainerNotYetDelivered]) {
        return IntegrationReportOrderStatus.ContainerNotYetDelivered;
      }

      if (selectedSubFilterId == IntegrationReportOrderStatus[IntegrationReportOrderStatus.ServiceCompleted]) {
        return IntegrationReportOrderStatus.ServiceCompleted;
      }

      if (selectedSubFilterId == IntegrationReportOrderStatus[IntegrationReportOrderStatus.ContainerOnSite]) {
        return IntegrationReportOrderStatus.ContainerOnSite;
      }
    }

    return IntegrationReportOrderStatus.None;
  }

  getContainerStatus(selectedContainerStatus: string) {
    if (!selectedContainerStatus) {
      return IntegrationReportContainerStatus.None;
    }

    if (selectedContainerStatus == ContainerStatus[ContainerStatus.DifferentContainerSize]) {
      return IntegrationReportContainerStatus.DifferentContainerSize;
    }

    if (selectedContainerStatus == ContainerStatus[ContainerStatus.DifferentContainerType]) {
      return IntegrationReportContainerStatus.DifferentContainerType;
    }

    if (selectedContainerStatus == ContainerStatus[ContainerStatus.DifferentWaste]) {
      return IntegrationReportContainerStatus.DifferentWaste;
    }

    if (selectedContainerStatus == ContainerStatus[ContainerStatus.NotMatched]) {
      return IntegrationReportContainerStatus.NotMatched;
    }

    return IntegrationReportContainerStatus.Matched;
  }

  getAgreementsFromDate(selectedOrderDate: string) {
    if (!selectedOrderDate) {
      if (this.data?.defaultAgreementsFromDate) {
        return this.data.defaultAgreementsFromDate;
      }
    
      return moment();
    }

    return moment(selectedOrderDate);
  }

  getMomentFromDate(date: Date) {
    if (!date) {   
      return moment();
    }

    return moment(date);
  }

  getSortColumn(sortColumn: string) {
    if (!sortColumn) {
      return IntegrationReportSortColumn.None;
    }

    if (sortColumn == IntegrationReportSortColumn[IntegrationReportSortColumn.ServiceFrequency]) {
      return IntegrationReportSortColumn.ServiceFrequency;
    }

    if (sortColumn == IntegrationReportSortColumn[IntegrationReportSortColumn.ContainersOnSite]) {
      return IntegrationReportSortColumn.ContainersOnSite;
    }

    if (sortColumn == IntegrationReportSortColumn[IntegrationReportSortColumn.TimeOnSite]) {
      return IntegrationReportSortColumn.TimeOnSite;
    }

    if (sortColumn == IntegrationReportSortColumn[IntegrationReportSortColumn.LatestDate]) {
      return IntegrationReportSortColumn.LatestDate;
    }

    if (sortColumn == IntegrationReportSortColumn[IntegrationReportSortColumn.LatestAction]) {
      return IntegrationReportSortColumn.LatestAction;
    }

    if (sortColumn == IntegrationReportSortColumn[IntegrationReportSortColumn.WasteType]) {
      return IntegrationReportSortColumn.WasteType;
    }

    return IntegrationReportSortColumn.AgreementReference;
  }

  getSortType(sortDirection: string) {
    if (!sortDirection) {
      return IntegrationReportSortType.None;
    }

    if (sortDirection == IntegrationReportSortType[IntegrationReportSortType.Ascending]) {
      return IntegrationReportSortType.Ascending;
    }

    return IntegrationReportSortType.Descending;
  }

  exportSlowMovers() {
    this.loading = true;
    this.setIsLoading(this.loading);
    this.customerId = this.pageHelperService.selectedCompanyId;
    let selectedDepotId = this.sessionStorageService.getItem("integration-report-selectedDepotId");
    if(selectedDepotId) {
      this.selectedDepotId = selectedDepotId;
    } else {
      this.selectedDepotId = null;
    }
    let selectedAccountManager = this.sessionStorageService.getItem("integration-report-selectedAccountManager");
    if(selectedAccountManager) {
      this.selectedAccountManager = selectedAccountManager;
    }
    let selectedAccountCode = this.sessionStorageService.getItem("integration-report-selectedAccountCode");
    if(selectedAccountCode) {
      this.selectedAccountCode = selectedAccountCode;
    }
    let selectedAccountType = this.sessionStorageService.getItem("integration-report-selectedAccountType");
    if(selectedAccountType) {
      this.selectedAccountType = selectedAccountType;
    }
    let selectedAccountCategory = this.sessionStorageService.getItem("integration-report-selectedAccountCategory");
    if(selectedAccountCategory) {
      this.selectedAccountCategory = selectedAccountCategory;
    }
    let selectedCustomer = this.sessionStorageService.getItem("integration-report-selectedCustomer");
    if(selectedCustomer) {
      this.selectedCustomer = selectedCustomer;
    }   
    let selectedAssetLocationId = this.sessionStorageService.getItem("integration-report-selectedAssetLocationId");
    if(selectedAssetLocationId) {
      this.selectedAssetLocationId = selectedAssetLocationId;
    }
    let selectedVehicleType = this.sessionStorageService.getItem("dashboard-active-selectedVehicleType");
    if(selectedVehicleType) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }

    this.apiCall = this._reportsService
      .exportSlowMovers(
        this.customerId,
        selectedDepotId,
        selectedAccountManager,
        selectedAccountCode,
        selectedAccountCategory,
        selectedAccountType,
        selectedCustomer,
        selectedAssetLocationId, 
        this.getAssetTypeClassification(selectedVehicleType))
      .subscribe(data => {
        this.loading = false;
        this.setIsLoading(this.loading);
        let filename = data.fileName;
        let blob: Blob = data.data;
        let a = document.createElement('a');
        a.download = filename;
        a.href = window.URL.createObjectURL(blob);
        a.click();
      }, error => {
        debugger;
      });
  }

  exportContainersOnSite() {
    this.loading = true;
    this.setIsLoading(this.loading);
    this.customerId = this.pageHelperService.selectedCompanyId;
    let selectedDepotId = this.sessionStorageService.getItem("integration-report-selectedDepotId");
    if(selectedDepotId) {
      this.selectedDepotId = selectedDepotId;
    } else {
      this.selectedDepotId = null;
    }
    let selectedAccountManager = this.sessionStorageService.getItem("integration-report-selectedAccountManager");
    if(selectedAccountManager) {
      this.selectedAccountManager = selectedAccountManager;
    }
    let selectedAccountCode = this.sessionStorageService.getItem("integration-report-selectedAccountCode");
    if(selectedAccountCode) {
      this.selectedAccountCode = selectedAccountCode;
    }
    let selectedAccountCategory = this.sessionStorageService.getItem("integration-report-selectedAccountCategory");
    if(selectedAccountCategory) {
      this.selectedAccountCategory = selectedAccountCategory;
    }
    let selectedCustomer = this.sessionStorageService.getItem("integration-report-selectedCustomer");
    if(selectedCustomer) {
      this.selectedCustomer = selectedCustomer;
    }   
    let selectedAssetLocationId = this.sessionStorageService.getItem("integration-report-selectedAssetLocationId");
    if(selectedAssetLocationId) {
      this.selectedAssetLocationId = selectedAssetLocationId;
    }
    let selectedVehicleType = this.sessionStorageService.getItem("dashboard-active-selectedVehicleType");
    if(selectedVehicleType) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }

    this.apiCall = this._reportsService
      .exportContainersOnSite(
        this.customerId,
        selectedDepotId,
        selectedAccountManager,
        selectedAccountCode,
        selectedAccountCategory,
        selectedCustomer,
        selectedAssetLocationId, 
        this.getAssetTypeClassification(selectedVehicleType))
      .subscribe(data => {
        this.loading = false;
        this.setIsLoading(this.loading);
        let filename = data.fileName;
        let blob: Blob = data.data;
        let a = document.createElement('a');
        a.download = filename;
        a.href = window.URL.createObjectURL(blob);
        a.click();
      }, error => {
        debugger;
      });
  }  

  toggleRow(agreementReference) {
    let agreement = this.data?.agreements?.items?.find(i => i.reference == agreementReference);

    if (agreement == null) {
      return;
    }

    if (!agreement.retrievedAssignments) {
      this._reportsService
        .getAgreementDetails(
          agreement.depotId,
          agreementReference)
        .subscribe(details => {
          agreement.contactEmail = details.contactEmail;
          agreement.contactName = details.contactName;
          agreement.contactNumber = details.contactNumber;
          agreement.notes = details.notes;
          agreement.retrievedAssignments = details.assignments;
          }, error => {
            debugger;
          });
    }

    if (this.expandedAgreements.includes(agreementReference)) {
      const index = this.expandedAgreements.indexOf(agreementReference);
      if (index > -1) {
        this.expandedAgreements.splice(index, 1);
      }
    } else {
      this.expandedAgreements.push(agreementReference);
    }
  }

  getLocation(locationId: string) : CustomerLocationDto{
    return this.locations.find(a => a.id == locationId);
  }

  checkForSubFilter() {
    if (this.sessionStorageService.getItem("integration-report-selectedShowMode") == ShowMode[ShowMode.NoContainerOnSite]) {
      this.showSubFilter = true;
      this.showNewOrderDate = false;
      this.subFilterList = this.NoContainerOnSiteFilterList;
      return;
    }

    if (this.sessionStorageService.getItem("integration-report-selectedShowMode") == ShowMode[ShowMode.NewOrders]) {
      this.showSubFilter = true;
      this.showNewOrderDate = true;
      this.subFilterList = this.NewOrdersFilterList;
      return;
    }

    this.showSubFilter = false;
    this.showNewOrderDate = false;
    this.selectedSubFilterId = null;
    this.sessionStorageService.removeItem("integration-report-selectedSubFilterId");    
  }

  dateFilterChanged(newValue) {
    if (newValue) {
      this.localStorageService.setItem("integration-report-selectedOrderDate", JSON.stringify(newValue));
    }
    else {
      this.localStorageService.removeItem("integration-report-selectedOrderDate")
    }

    this.getData();
  }

  showModeChange(newValue) {
    this.resetHiddenFiltersForShowMode();

    if (newValue == ShowMode[ShowMode.SlowMovers]) {
      this.showSlowMovers = true;
      this.sortColumn = IntegrationReportSortColumn[IntegrationReportSortColumn.TimeOnSite];
      this.sortDirection = IntegrationReportSortType[IntegrationReportSortType.Descending];
    }
    else if (newValue == ShowMode[ShowMode.RecentlyUpdated] || newValue == ShowMode[ShowMode.MissingCollection] || newValue == ShowMode[ShowMode.MovedContract]) {
      this.showSlowMovers = false;
      this.sortColumn = IntegrationReportSortColumn[IntegrationReportSortColumn.LatestDate];
      this.sortDirection = IntegrationReportSortType[IntegrationReportSortType.Descending];
    }
    else {
      this.showSlowMovers = false;
      this.sortColumn = IntegrationReportSortColumn[IntegrationReportSortColumn.AgreementReference];
      this.sortDirection = IntegrationReportSortType[IntegrationReportSortType.Descending];
    }

    if (newValue == ShowMode[ShowMode.ContainerOnSite]) {
      this.showContainerOnSite = true;
    }
    else {
      this.showContainerOnSite = false;
    }    

    if (newValue) {
      this.sessionStorageService.setItem("integration-report-selectedShowMode", newValue);
    }
    else {
      this.sessionStorageService.removeItem("integration-report-selectedShowMode")
    }

    this.checkForSubFilter()
    this.getData();
  }

  private resetHiddenFiltersForShowMode() {
    this.clearAgreementFilter();
    this.clearContainerStatusFilter();
    this.clearAccountFilters();
    this.clearSubFilter();
    this.clearOrderDateFilter();
  }

  private clearAgreementFilter() {
    this.selectedExternalReference = null;
    this.agreementSearchControl.setValue("");
    this.sessionStorageService.removeItem("integration-report-selectedExternalReference");
  }

  private clearContainerStatusFilter() {
    this.selectedContainerStatus = null;
    this.sessionStorageService.removeItem("integration-report-selectedContainerStatus");
  }

  private clearSubFilter() {
    this.selectedSubFilterId = null;
    this.sessionStorageService.removeItem("integration-report-selectedSubFilterId");
  }

  private clearOrderDateFilter() {
    this.orderFromDate = new UntypedFormControl(null);
    this.localStorageService.removeItem("integration-report-selectedOrderDate");
  }

  private clearAccountFilters() {
    this.selectedAccountManager = null;
    this.selectedAccountCategory = null;
    this.selectedAccountCode = null;
    this.selectedAccountType = null;
    this.selectedCustomer = null;
    this.selectedWasteTypeNames = [];

    this.sessionStorageService.removeItem("integration-report-selectedAccountManager");
    this.sessionStorageService.removeItem("integration-report-selectedAccountCategory");
    this.sessionStorageService.removeItem("integration-report-selectedAccountCode");
    this.sessionStorageService.removeItem("integration-report-selectedAccountType");
    this.sessionStorageService.removeItem("integration-report-selectedCustomer");
    this.clearStoredWasteTypeNames(this.pageHelperService.selectedCompanyId);
  }

  containerStatusChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("integration-report-selectedContainerStatus", newValue);
    }
    else {
      this.sessionStorageService.removeItem("integration-report-selectedContainerStatus")
    }

    this.getData();
  }  

  checkAll(ev) {
    this.data.agreements.items.filter(i => i.reference).forEach(x => x.checked = ev.target.checked)
  }

  isAllChecked() {
    return this.data.agreements.items.filter(i => i.reference).every(x => x.checked) && this.data.agreements.items.filter(i => i.reference).some(x => x.checked);
  }

  agreementsSelected() {
    return this.data.agreements.items.filter(i => i.checked == true).length > 0;
  }

  agreementSelected() {
    return this.data.agreements.items.filter(i => i.checked == true).length == 1;
  }

  getContactDetails(agreement: IntegrationReportAgreementDto)
  {
    let details = "";

    if (agreement) {
      agreement.contactName = agreement.contactName?.trim();
      agreement.contactNumber = agreement.contactNumber?.trim();
      agreement.contactEmail = agreement.contactEmail?.trim();
    }

    if (agreement?.contactName) {
      details += agreement.contactName + (agreement?.contactNumber || agreement?.contactEmail ? " - ": "");
    }

    if (agreement?.contactNumber) {
      details += agreement.contactNumber + (agreement?.contactEmail ? " - ": "");
    }
     
    if (agreement?.contactEmail) {
      details += agreement.contactEmail;
    }

    details = details.trim();

    if (details.length > 200)
    {
      return details.substring(0, 200) + '...';
    }

    return details;
  }

  editContactDetails(reference) {
    if (!reference)
    {
      return;
    }

    let agreement = this.data.agreements.items.find(a => a.reference == reference);

    if (!agreement)
    {
      return;
    }

    const dialogRef = this.dialog.open(ContactDetailsDialog, {
      width: '600px',
      data: {
        title: "Contact",
        text: "Contract: " + reference,
        info: "Location: " + agreement.locationName,
        contactEmail: agreement.contactEmail,
        contactName: agreement.contactName,
        contactNumber: agreement.contactNumber,
        showCancel: true
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let dialogData = result as ContactDetailsDialogData;

        debugger;

        if (!dialogData)
        {
          return;
        }

        this._agreementsService.updateContactDetails(this.pageHelperService.selectedCompanyId, reference, dialogData.contactEmail, dialogData.contactName, dialogData.contactNumber).subscribe(response => {
          this.data.agreements.items.filter(a => a.locationId == agreement.locationId).forEach(element => {
            element.contactEmail = dialogData.contactEmail;
            element.contactName = dialogData.contactName;
            element.contactNumber = dialogData.contactNumber; 
          });
        }, error => {
          debugger;
        });
      }
    });
  }

  getNotes(agreement: IntegrationReportAgreementDto)
  {
    if (!agreement?.notes)
    {
      return "";
    }

    var notes = agreement.notes.trim();

    if (notes.length > 200)
    {
      return notes.substring(0, 200) + '...';
    }
    
    return notes;
  }

  editNotes(reference) {
    if (!reference)
    {
      return;
    }

    let agreement = this.data.agreements.items.find(a => a.reference == reference);

    if (!agreement)
    {
      return;
    }

    const dialogRef = this.dialog.open(NotesDialog, {
      width: '600px',
      data: {
        title: "Notes",
        text: "Contract: " + reference,
        info: "Location: " + agreement.locationName,
        notes: agreement.notes,
        showCancel: true
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let dialogData = result as NotesDialogData;

        debugger;

        if (!dialogData)
        {
          return;
        }

        this._agreementsService.updateNotes(this.pageHelperService.selectedCompanyId, reference, dialogData.notes).subscribe(response => {
          agreement.notes = dialogData.notes?.trim();
          agreement.hasNotes = agreement.notes ? true : false;
        }, error => {
          debugger;
        });
      }
    });
  }

  applyRental() {
    let checkedAgreements = this.data.agreements.items.filter(i => i.checked == true);

    if (!checkedAgreements.length)
    {
      return;
    }

    let title = `Apply Rental`;
    let text = this.getActionText(checkedAgreements);
    const dialogRef = this.dialog.open(RentalDialog, {
      width: '300px',
      data: {
        title: title,
        text: text,
        isCustomRental: false,
        rentalAmount: Math.max(this.defaultRentalAmountRoros, this.defaultRentalAmountSkips),
        showPrompt: true,
        showCancel: true
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let dialogData = result as RentalDialogData;

        if (!dialogData)
        {
          return;
        }

        let rentalAmount = Number(dialogData.rentalAmount);

        if (!rentalAmount || rentalAmount < 0)
        {
          rentalAmount = 0;
        }

        let customerId = this.pageHelperService.selectedCompanyId;
        let depotId = this.getDepotId(this.selectedDepotId);
        let request: AddAgreementRentalAmountsRequest = {
          customerId: customerId,
          depotId: depotId,
          rentalDays: this.defaultRentalDays,
          agreements: this.data.agreements.items,
          rentalAmounts: []
        };

        checkedAgreements.forEach(agreement => {
          let agreementRental = 0;

          if (dialogData.isCustomRental)
          {
            agreementRental = Math.floor(rentalAmount);
          }
          else if (agreement.assetTypeClassification === AssetTypeClassification.RoRo)
          {
            agreementRental = this.defaultRentalAmountRoros;
          }
          else
          {
            agreementRental = this.defaultRentalAmountSkips;
          }

          let agreementRentalAmount: AgreementRentalAmountDto = {
            customerId: customerId,
            isCustomRental: dialogData.isCustomRental,
            rentalAmount: agreementRental,
            externalReference: agreement.reference
          };

          request.rentalAmounts.push(agreementRentalAmount);
        });

        this._agreementsService.addAgreementRentalAmounts(
          request).subscribe(response => {
            response.agreements.forEach(a => a.checked = false);

            this.data.agreements.items = response.agreements;
            this.data.isAnyRent = response.isAnyRent;
            this.data.thisWeekRent = response.thisWeekRent;
            this.data.thisWeekRentDisplay = response.thisWeekRentDisplay;
            this.data.totalRent = response.totalRent;
            this.data.totalRentDisplay = response.totalRentDisplay;
        }, error => {
          debugger;
        });
      }
    });
  }

  removeRental() {
    let checkedAgreements = this.data.agreements.items.filter(i => i.checked == true);

    if (!checkedAgreements.length)
    {
      return;
    }

    let title = `Remove Rental`;
    let text = this.getActionText(checkedAgreements);
    const dialogRef = this.dialog.open(RentalDialog, {
      width: '300px',
      data: {
        title: title,
        text: text,
        isCustomRental: false,
        rentalAmount: 0,
        showPrompt: false,
        showCancel: true
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let dialogData = result as RentalDialogData;

        if (!dialogData)
        {
          return;
        }

        let customerId = this.pageHelperService.selectedCompanyId;
        let depotId = this.getDepotId(this.selectedDepotId);
        let request: AddAgreementRentalAmountsRequest = {
          customerId: customerId,
          depotId: depotId,
          rentalDays: this.defaultRentalDays,
          agreements: this.data.agreements.items,
          rentalAmounts: []
        };

        checkedAgreements.forEach(agreement => {
          let agreementRentalAmount: AgreementRentalAmountDto = {
            customerId: customerId,
            isCustomRental: dialogData.isCustomRental,
            rentalAmount: 0,
            externalReference: agreement.reference
          };

          request.rentalAmounts.push(agreementRentalAmount);
        });

        this._agreementsService.addAgreementRentalAmounts(
          request).subscribe(response => {
            response.agreements.forEach(a => a.checked = false);
                        
            this.data.agreements.items = response.agreements;
            this.data.isAnyRent = response.isAnyRent;
            this.data.thisWeekRent = response.thisWeekRent;
            this.data.thisWeekRentDisplay = response.thisWeekRentDisplay;
            this.data.totalRent = response.totalRent;
            this.data.totalRentDisplay = response.totalRentDisplay;
        }, error => {
          debugger;
        });
      }
    });
  }
  
  applyActions() {
    let checkedAgreements = this.data.agreements.items.filter(i => i.checked == true);

    if (!checkedAgreements.length || checkedAgreements.length != 1 || !checkedAgreements[0].containers || !checkedAgreements[0].containers.length)
    {
      return;
    }

    let title = `Set Contract Actioned`;
    let text = this.getActionText(checkedAgreements);
    let containers: ActionsDialogContainer[] = checkedAgreements[0].containers.map(c => ({id: c.name, daysOnSite: c.daysOnSite, isChecked: false}));
    let data = {
      title: title,
      text: text,
      containers: containers,
      isScheduled: false,
      showCancel: true
    };

    const dialogRef = this.dialog.open(ActionsDialog, {
      width: '300px',
      data: data,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let dialogData = result as ActionsDialogData;

        if (!dialogData?.containers)
        {
          return;
        }

        let checkedContainers = dialogData.containers.filter(c => c.isChecked);

        if (checkedContainers.length <= 0)
        {
          return;
        }

        if (checkedAgreements.length != 1)
        {
          return;
        }

        let customerId = this.pageHelperService.selectedCompanyId;
        let agreement = checkedAgreements[0];
        let containers: AgreementActionContainerDto[] = checkedContainers.map(c => ({assetId: c.id, daysOnSite: c.daysOnSite}))
        let agreementAction: AgreementActionDto = {
          customerId: customerId,
          externalReference: agreement.reference,
          quantity: Math.abs(Math.floor(checkedContainers.length)),
          isScheduled: dialogData.isScheduled,
          lastActionDescription: agreement.latestActionDescription,
          lastActionDate: agreement.latestActionDate,
          containers: containers
        };

        this._agreementsService.actionContainers(
          agreementAction).subscribe(() => {
            this.data.agreements.items.forEach(a => {
              a.checked = false;
              if (checkedAgreements.find(c => c.reference == a.reference)) {
                a.isActioned = false;
              }
            });
        }, error => {
          debugger;
        });
      }
    });
  }

  manualReset() {
    let checkedAgreements = this.data.agreements.items.filter(i => i.checked == true);

    if (!checkedAgreements.length || checkedAgreements.length != 1 || !checkedAgreements[0].containers || !checkedAgreements[0].containers.length)
    {
      return;
    }

    let title = `Manual Reset`;
    let text = this.getActionText(checkedAgreements);
    let resetDate = this.getMomentFromDate(new Date());
    let containers: ResetDialogContainer[] = checkedAgreements[0].containers.map(c => ({id: c.name, startDate: (c.startDate ? c.startDate : resetDate), resetDate: resetDate, daysOnSite: c.daysOnSite, isChecked: false}));
    let data = {
      title: title,
      text: text,
      containers: containers,
      showCancel: true
    };

    const dialogRef = this.dialog.open(ResetDialog, {
      width: '300px',
      data: data,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let dialogData = result as ResetDialogData;

        if (!dialogData?.containers)
        {
          return;
        }

        let checkedContainers = dialogData.containers.filter(c => c.isChecked);

        if (checkedContainers.length <= 0)
        {
          return;
        }

        if (checkedAgreements.length != 1)
        {
          return;
        }

        let customerId = this.pageHelperService.selectedCompanyId;
        let agreement = checkedAgreements[0];
        let containers: ManualResetContainerDto[] = checkedContainers.map(c => ({assetId: c.id, startDate: c.startDate, resetDate: c.resetDate, daysOnSite: c.daysOnSite}))
        let manualReset: ManualResetDto = {
          customerId: customerId,
          externalReference: agreement.reference,
          containers: containers
        };

        this._agreementsService.manualReset(manualReset)
          .subscribe(() => {
            this.data.agreements.items.forEach(a => {
              a.checked = false;
              // a.retrievedAssignments = null;
              if (checkedAgreements.find(c => c.reference == a.reference)) {
                /*
                if (this.expandedAgreements) {
                  this.expandedAgreements = this.expandedAgreements.filter(e => e != a.reference);
                }
                */
                if (a.containers) {
                  a.containers.forEach(c => {
                    if (containers.find(x => x.assetId == c.name)) {
                      c.daysOnSite = 0;
                      c.daysOnSiteDisplay = "";
                      c.rentalTotal = 0;
                    }
                  });
                }
              }

              this._reportsService
              .getIntegrationReport(
                this.customerId,
                this.getDepotId(this.selectedDepotId),
                [],
                this.getAssetTypeClassification(''),
                this.getShowMode(''),
                this.getOrderStatus('', ''),
                this.getContainerStatus(''),
                moment(),
                null,
                a.reference,
                [],
                '',
                '',
                '',
                '',
                '',
                '',
                this.getSortColumn(''),
                this.getSortType(''),
                1,
                9999)
              .subscribe(data => {
                if (data?.agreements?.items) {
                  a.serviceFrequency = data?.agreements?.items[0].serviceFrequency;
                  a.serviceFrequencyDisplay = data?.agreements?.items[0].serviceFrequencyDisplay;
                  a.rentalAmount = data?.agreements?.items[0].rentalAmount;
                  a.rentalAmountDisplay = data?.agreements?.items[0].rentalAmountDisplay;
                  a.rentalTotal = data?.agreements?.items[0].rentalTotal;
                  a.rentalTotalDisplay = data?.agreements?.items[0].rentalTotalDisplay;
                }
              }, error => {
                debugger;
              });

              this._reportsService
              .getAgreementDetails(
                a.depotId,
                a.reference)
              .subscribe(details => {
                a.retrievedAssignments = details.assignments;
                }, error => {
                  debugger;
                });
            });
        }, error => {
          debugger;
        });
      }
    });
  }

  getActionText(checkedAgreements) {
    return checkedAgreements.length === 1 ? `${checkedAgreements[0].reference}` : `${checkedAgreements.length} contract(s) selected`;
  }

  sortData(columnName) {
    if (this.sortColumn == columnName) {
      this.sortDirection = this.sortDirection == IntegrationReportSortType[IntegrationReportSortType.Ascending]
        ? IntegrationReportSortType[IntegrationReportSortType.Descending]
        : IntegrationReportSortType[IntegrationReportSortType.Ascending];
    }
    else {
      this.sortDirection = IntegrationReportSortType[IntegrationReportSortType.Descending]
    }

    this.sortColumn = columnName;
    this.getData()
  }

  assetTypeChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("integration-report-selectedAssetTypeId", newValue);
    }
    else {
      this.assetTypeSearchControl.setValue("");
      this.sessionStorageService.removeItem("integration-report-selectedAssetTypeId")
    }

    this.getData();
  }

  agreementChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("integration-report-selectedExternalReference", newValue);
    }
    else {
      this.agreementSearchControl.setValue("");
      this.sessionStorageService.removeItem("integration-report-selectedExternalReference")
    }

    this.getData();
  }

  locationChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("integration-report-selectedAssetLocationId", newValue);
    }
    else {
      this.locationSearchControl.setValue("");
      this.sessionStorageService.removeItem("integration-report-selectedAssetLocationId")
    }

    this.getData();
  }

  depotChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("integration-report-selectedDepotId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("integration-report-selectedDepotId")
    }

    this.getData();
  }

  subFilterChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("integration-report-selectedSubFilterId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("integration-report-selectedSubFilterId")
    }

    this.getData();
  }

  accountManagerChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("integration-report-selectedAccountManager", newValue);
    }
    else {
      this.sessionStorageService.removeItem("integration-report-selectedAccountManager")
    }

    this.getData();
  }

  accountCategoryChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("integration-report-selectedAccountCategory", newValue);
    }
    else {
      this.sessionStorageService.removeItem("integration-report-selectedAccountCategory")
    }

    this.getData();
  }

  accountCodeChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("integration-report-selectedAccountCode", newValue);
    }
    else {
      this.sessionStorageService.removeItem("integration-report-selectedAccountCode")
    }

    this.getData();
  }

  accountTypeChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("integration-report-selectedAccountType", newValue);
    }
    else {
      this.sessionStorageService.removeItem("integration-report-selectedAccountType")
    }

    this.getData();
  }

  customerChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("integration-report-selectedCustomer", newValue);
    }
    else {
      this.sessionStorageService.removeItem("integration-report-selectedCustomer")
    }

    this.getData();
  }

  wasteTypeChange(newValue: string[]) {
    this.saveStoredWasteTypeNames(this.pageHelperService.selectedCompanyId, newValue || []);
    this.getDataDebounced();
  }

  getDataDebounced() {
    if (this.getDataDebounceTimer) {
      clearTimeout(this.getDataDebounceTimer);
    }

    this.getDataDebounceTimer = setTimeout(() => {
      this.getDataDebounceTimer = null;
      this.getData();
    }, this.getDataDebounceMs);
  }

  selectedVehicleTypeValueChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("dashboard-active-selectedVehicleType", JSON.stringify(newValue));
    }
    else {
      this.sessionStorageService.removeItem("dashboard-active-selectedVehicleType")
    }

    this.getData();    
  }

  loadListData(data: IntegrationReportDataDto) {
    // Get list data from the provided data
    const locationsList: DropDownListItem[] = [];
    const assetTypeList: DropDownListItem[] = [];
    const agreementList: DropDownListItem[] = [];
    const accountManagerList: DropDownListItem[] = [];
    const accountCategoryList: DropDownListItem[] = [];
    const accountCodeList: DropDownListItem[] = [];
    const accountTypeList: DropDownListItem[] = [];
    const customerList: DropDownListItem[] = [];
    const wasteTypeList: DropDownListItem[] = [];

    let agreements = data?.agreements?.items;

    if (!agreements) {
      agreements = [];
    }
    
    agreements.forEach(agreement => {
      let location = this.locations.find(l => l.id == agreement.locationId);
    
      if (location.displayName && !locationsList.find(l => l.name == location.displayName)) {
        let locationItem = new DropDownListItem()
        locationItem.id = location.id;
        locationItem.name = location.displayName;
        locationsList.push(locationItem)
      }

      if (agreement.assetTypeId && agreement.assetTypeName && !assetTypeList.find(l => l.id == String(agreement.assetTypeId))) {
        let agreementType = new DropDownListItem()
        agreementType.id = String(agreement.assetTypeId);
        agreementType.name = agreement.assetTypeName;
        assetTypeList.push(agreementType)

        agreement.containers.forEach(container => {
          if (container.assetTypeId && container.assetTypeName && !assetTypeList.find(l => l.id == String(container.assetTypeId))) {
            let containerType = new DropDownListItem()
            containerType.id = String(container.assetTypeId);
            containerType.name = container.assetTypeName;
            assetTypeList.push(containerType)
          }          
        });
      }

      if (agreement.reference && !agreementList.find(l => l.id == agreement.reference.toLowerCase())) {
        let agreementRef = new DropDownListItem()
        agreementRef.id = agreement.reference.toLowerCase();
        agreementRef.name = agreement.reference;
        agreementList.push(agreementRef)
      }

      if (agreement.wasteTypeName && agreement.wasteTypeName != '' && !wasteTypeList.find(l => l.id == agreement.wasteTypeName)) {
        let wasteType = new DropDownListItem()
        wasteType.id = agreement.wasteTypeName;
        wasteType.name = agreement.wasteTypeName
        wasteTypeList.push(wasteType)
      }

      if (agreement.accountManager && agreement.accountManager != '' && !accountManagerList.find(l => l.id == agreement.accountManager)) {
        let assignmentStatus = new DropDownListItem()
        assignmentStatus.id = agreement.accountManager;
        assignmentStatus.name = agreement.accountManager
        accountManagerList.push(assignmentStatus)
      }

      if (agreement.accountCategory && agreement.accountCategory != '' && !accountCategoryList.find(l => l.id == agreement.accountCategory)) {
        let assignmentStatus = new DropDownListItem()
        assignmentStatus.id = agreement.accountCategory;
        assignmentStatus.name = agreement.accountCategory
        accountCategoryList.push(assignmentStatus)
      }

      if (agreement.accountCode && agreement.accountCode != '' && !accountCodeList.find(l => l.id == agreement.accountCode)) {
        let assignmentStatus = new DropDownListItem()
        assignmentStatus.id = agreement.accountCode;
        assignmentStatus.name = agreement.accountCode
        accountCodeList.push(assignmentStatus)
      }

      if (agreement.accountType && agreement.accountType != '' && !accountTypeList.find(l => l.id == agreement.accountType)) {
        let assignmentStatus = new DropDownListItem()
        assignmentStatus.id = agreement.accountType;
        assignmentStatus.name = agreement.accountType
        accountTypeList.push(assignmentStatus)
      }

      if (agreement.customerName && agreement.customerName != '' && !customerList.find(l => l.id == agreement.customerName)) {
        let assignmentStatus = new DropDownListItem()
        assignmentStatus.id = agreement.customerName;
        assignmentStatus.name = agreement.customerName
        customerList.push(assignmentStatus)
      }
    })
      
    this.locationsList = locationsList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })
    this.filteredLocationsList = locationsList;

    this.assetTypeList = assetTypeList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })

    this.agreementList = agreementList.sort(function(a, b){
      if(a.name === b.name) { return 0; }
      if(!a.name) { return 1; }
      if(!b.name) { return -1; }
      if(a.name.includes(" ")) { return 1; }
      if(b.name.includes(" ")) { return -1; }      
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    });
    this.filteredAgreementList = agreementList;

    this.accountManagerList = accountManagerList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })

    this.accountCategoryList = accountCategoryList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })

    this.accountCodeList = accountCodeList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })

    this.accountTypeList = accountTypeList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })

    this.customerList = customerList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })

    const mergedWasteTypeList = [...(this.wasteTypeList || [])];
    wasteTypeList.forEach(wasteType => {
      if (!mergedWasteTypeList.find(item => item.id == wasteType.id)) {
        mergedWasteTypeList.push(wasteType);
      }
    });

    this.wasteTypeList = mergedWasteTypeList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })
    this.saveStoredWasteTypeList(this.customerId, this.wasteTypeList);
  }

  onLocationSearch(value: string) { 
    if (value == "" || !value) {
      this.filteredLocationsList = this.locationsList;
    }

    let filter = value.toLowerCase();
    this.filteredLocationsList = this.locationsList.filter(l => l.name.toLowerCase().includes(filter));
  }

  onAgreementSearch(value: string) {
    if (value == "" || !value) {
      this.filteredAgreementList = this.agreementList;
    }

    let filter = value.toLowerCase();
    return this.filteredAgreementList = this.agreementList.filter(a => a.name.toLowerCase().includes(filter));
  }

  goToLocation(locationId: string) {
    this.router.navigate([`/location/${locationId}`]);
  }

  getLatestActionStyle(agreement: IntegrationReportAgreementDto) {
    let style = "";

    switch (agreement.isActioned) {     
      case null:
        break;
      case false:
        style = "slow-low";
        break;
      default:
        style = "ok";
    }

    return style;
  }

  getAssignmentStatusStyle(container: IntegrationReportContainerDto) {
    if (this.selectedShowMode === ShowMode[ShowMode.SlowMovers]) {
      return this.getAgreementSlowMoverClass(container.daysOnSite);
    }

    let style = "";
    if (!container.status) {
      return "";
    }

    switch (container.status) {     
      case IntegrationReportContainerStatus.DifferentContainerSize:
        style = "different-size";
        break;
      case IntegrationReportContainerStatus.DifferentWaste:
        style = "different-waste";
        break;
      case IntegrationReportContainerStatus.DifferentContainerType:
        style = "different-type";
        break;
      case IntegrationReportContainerStatus.NotMatched:
        style = "no-agreement";
        break;
      default:
        style = "ok";
    }

    return style;
  }

  getAssignmentStatusDescription(container: IntegrationReportContainerDto) {
    switch (container.status) {  
      case IntegrationReportContainerStatus.DifferentContainerSize:
        return "Different size";
      case IntegrationReportContainerStatus.DifferentWaste:
        return "Different waste";
      case IntegrationReportContainerStatus.DifferentContainerType:
        return "Different type";
      case IntegrationReportContainerStatus.NotMatched:
        return "No agreement";
      default:
        return "Ok";
    }
  }

  getAgreementSlowMoverClass(daysOnSite?: number): string {
    if (!daysOnSite) {
      return "";
    }

    if (daysOnSite >= 28 && daysOnSite < 60) {
      return "slow-low"
    }
    if (daysOnSite >= 60 && daysOnSite < 100) {
      return "slow-medium"
    }
    if (daysOnSite >= 100) {
      return "slow-high"
    }

    return "";
  }

  filterLocations(val: string): CustomerLocationDto[] {
    if (!this.locations) {
      return [];
    }

    return this.locations.filter(l => l.displayName.toLowerCase().includes(val.toLowerCase()));
  }
}

@Component({
    selector: 'apply-contact-details-dialog',
    templateUrl: './integration-report-contact-details-dialog.component.html',
    standalone: false
})
export class ContactDetailsDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ContactDetailsDialogData) {}
}

@Component({
    selector: 'apply-notes-dialog',
    templateUrl: './integration-report-notes-dialog.component.html',
    standalone: false
})
export class NotesDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: NotesDialogData) {}
}

@Component({
    selector: 'apply-rental-dialog',
    templateUrl: './integration-report-rental-dialog.component.html',
    standalone: false
})
export class RentalDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: RentalDialogData) {}
}

@Component({
    selector: 'apply-actions-dialog',
    templateUrl: './integration-report-actions-dialog.component.html',
    standalone: false
})
export class ActionsDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ActionsDialogData) {}

  containersChecked(containers: ActionsDialogContainer[]) {
    if (!containers) {
      return false;
    }

    return containers.filter(c => c.isChecked).length > 0;
  }  
}

@Component({
    selector: 'manual-reset-dialog',
    templateUrl: './integration-report-reset-dialog.component.html',
    standalone: false
})
export class ResetDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ResetDialogData) {}

  containersChecked(containers: ResetDialogContainer[]) {
    if (!containers) {
      return false;
    }

    return containers.filter(c => c.isChecked).length > 0;
  }  
}
